export default [
  {
    key: 'toNo',
    label: 'field.match',
    rules: 'required|decimal:2|min_value:0',
    type: 'currency',
    cols: 12,
  },
]
